function normalizeProgram (program) {
  if (!program) return
  const cleaned = program.replace(/\s/g, '')
  if (cleaned.startsWith('RMS-OWN')) return 'RMS-OWN'
  if (cleaned.startsWith('RMS-PRG')) return 'RMS-PRG'
  return program
}

module.exports = { normalizeProgram }
